import React from 'react'

class DocumentTitle extends React.Component {
  componentDidMount = () => {
    document.title = this.props.title
  }
  componentWillUnmount() {
    document.title = `AirRefund CRM`
  }

  render() {
    return null
  }
}

export default DocumentTitle



// WEBPACK FOOTER //
// ./src/component/DocumentTitle.js